import React from 'react';
import ErrorAlert from '../ErrorAlert/ErrorAlert';

interface AuthErrorAlertProps {
  message?: string;
}

function AuthErrorAlert({
  message
}: Readonly<AuthErrorAlertProps>): React.ReactElement {
  return <ErrorAlert message={message} className={message ? 'mt-4' : ''} />;
}

export default AuthErrorAlert;
